const Encode = {
    // 关键！请将 "YOUR_SECRET_KEY" 替换为您的实际密钥。
    // IMPORTANT! Replace "YOUR_SECRET_KEY" with your actual key.
    KEY: "qezlitjmrpl1000wfb",

    _A: 'A'.charCodeAt(0),
    _Z: 'Z'.charCodeAt(0),
    _a: 'a'.charCodeAt(0),
    _z: 'z'.charCodeAt(0),

    numberList: [
        "A9", "b0", "c9", "D0", "e8", "F9", "g0", "H0", "i2", "j7", "k1", "L5",
        "M4", "N5", "O9", "P5", "q9", "R8", "S5", "T9", "u5", "V7", "W1", "X0",
        "Y4", "Z8", "a2", "B8", "C4", "d6", "f7", "h1", "I9", "J3", "k4", "L9",
        "m3", "n2", "O5", "P0", "Q7", "S3", "t8", "U6", "v3", "w9", "X2", "y5",
        "z1", "A0", "B6", "c8", "D1", "g8", "I7", "J8", "K0", "l4", "M5", "n4",
        "Q4", "r5", "s6", "t5", "U0", "w2", "x4", "y1", "Z3", "A6", "b2", "D7",
        "E4", "f6", "G1", "h5", "I3", "l3", "M2", "n8", "o7", "p3", "q0", "r6",
        "S9", "t1", "u9", "w6", "y7", "Z7", "a3", "c6", "d3", "F8", "H6", "J5",
        "k2", "M0", "N9", "O4", "P1", "q6", "r4", "t0", "u7", "V5", "w5", "X9",
        "Y3", "A4", "C2", "G6", "i6", "K3", "M9", "o2", "Q1", "u2", "x8", "Z0",
        "a8", "c5", "e3", "h2", "I4", "K7", "l2", "m8", "n7", "p6"
    ],

    _getEncodeKey: function() {
        return this.KEY.split('');
    },

    encode: function(str) {
        if (!str) {
            return "";
        }
        const sb = [];
        const charArray = str.split('');
        const shiftsIn = new Array(charArray.length).fill(0);
        const shiftsIn1 = new Array(charArray.length + 2).fill(0);

        const encodeKey = this._getEncodeKey();
        let index = 0;
        for (let i = 0; i < shiftsIn1.length; i++) {
            if (index > encodeKey.length - 1) {
                index = 0;
            }
            shiftsIn1[i] = encodeKey[index].charCodeAt(0);
            index++;
        }

        for (let i = charArray.length - 2; i >= 0; i--) {
            shiftsIn[i] = (shiftsIn1[i] + shiftsIn1[i + 1]) % 26;
        }

        let indexNum = 0;
        for (let i = 0; i < charArray.length; i++) {
            const c = charArray[i];
            const cCode = c.charCodeAt(0);

            if (this._isSpecialCharOrNum(c)) {
                const i1 = shiftsIn[i];
                indexNum = (cCode + i1) % this.numberList.length;
                sb.push(this.numberList[indexNum]);
            } else if ((c >= 'A' && c <= 'Z') || (c >= 'a' && c <= 'z')) {
                let i1 = cCode + shiftsIn[i];
                if (c <= 'Z' && i1 > this._Z) {
                    i1 = (this._A - 1) + (i1 - this._Z);
                } else if (c <= 'z' && i1 > this._z) {
                    i1 = (this._a - 1) + (i1 - this._z);
                }
                sb.push(String.fromCharCode(i1));
            } else {
                sb.push(c);
            }
        }
        return sb.join('');
    },

    decode: function(str) {
        if (!str) {
            return "";
        }
        let sb = "";
        const charArray = str.split('');
        const shiftsIn = new Array(charArray.length).fill(0);
        const shiftsIn1 = new Array(charArray.length + 2).fill(0);

        const encodeKey = this._getEncodeKey();
        let index = 0;
        for (let i = 0; i < shiftsIn1.length; i++) {
            if (index > encodeKey.length - 1) {
                index = 0;
            }
            shiftsIn1[i] = encodeKey[index].charCodeAt(0);
            index++;
        }

        for (let i = charArray.length - 2; i >= 0; i--) {
            shiftsIn[i] = (shiftsIn1[i] + shiftsIn1[i + 1]) % 26;
        }

        let convertIndex = 0;
        let i = 0;
        while (i < charArray.length) {
            let c1 = (i + 1 < charArray.length) ? charArray[i + 1] : '';
            const c1Code = c1.charCodeAt(0);

            if (i === charArray.length - 1) {
                const i1 = charArray[i].charCodeAt(0) - shiftsIn[shiftsIn.length - 1];
                sb += String.fromCharCode(i1);
            } else if (c1Code >= 48 && c1Code <= 57) { // 检查 c1 是否是数字 '0'-'9'
                let i1 = shiftsIn[convertIndex];
                if (i + 1 === charArray.length - 1) {
                    i1 = shiftsIn[shiftsIn.length - 1];
                }
                const combined = charArray[i] + c1;
                const indexOf = this.numberList.indexOf(combined);
                sb += String.fromCharCode(this._numConvert(indexOf - i1));
                i++; // 额外增加 i，因为我们已经处理了两个字符
            } else if ((charArray[i] >= 'A' && charArray[i] <= 'Z') || (charArray[i] >= 'a' && charArray[i] <= 'z')) {
                let i1 = charArray[i].charCodeAt(0) - shiftsIn[convertIndex];
                if (charArray[i] <= 'Z' && i1 < this._A) {
                    i1 = (this._Z + 1) - (this._A - i1);
                } else if (charArray[i] >= 'a' && i1 < this._a) {
                    i1 = (this._z + 1) - (this._a - i1);
                }
                sb += String.fromCharCode(i1);
            } else {
                sb += charArray[i];
            }
            convertIndex++;
            i++;
        }
        return sb;
    },

    _numConvert: function(index) {
        if (index < 32) {
            return this._numConvert(index + this.numberList.length);
        }
        return index;
    },

    _isSpecialCharOrNum: function(c) {
        const code = c.charCodeAt(0);
        // 对应 Kotlin 代码中的 47..58, 也就是字符 '/' 到 ':'
        if (code >= 47 && code <= 58) {
            return true;
        }
        switch (code) {
            case 32: // space
            case 34: // "
            case 39: // '
            case 44: // ,
            case 45: // -
            case 91: // [
            case 93: // ]
            case 123: // {
            case 125: // }
                return true;
            default:
                return false;
        }
    }
};
module.exports = Encode;
// 1. 设置你的密钥
// Encode.KEY = "qezlitjmrpl1000wfb"; // 使用一个真实的密钥

let keyData = {
    ouohAo: "ABHY0065208",
    exjMnbnOszhAso: "987654321",
    gelHbre: 30003,
    ahawPcke: 17177,
    btnxvcn: 201,
};
keyData = JSON.stringify(keyData);
console.log(keyData, 33333111);
const encryptedData = Encode.encode(keyData);
console.log("加密：",encryptedData)

// 2. 编码字符串
const originalString = "{\"ouohAo\":\"ABHY0065208\",\"exjMnbnOszhAso\":\"987654321\",\"gelHbre\":30003,\"ahawPcke\":17177,\"btnxvcn\":\"201\"}";
const encodedString = Encode.encode(originalString);
// console.log("Original:", originalString);
// console.log("Encoded:", encodedString);

// 3. 解码字符串
const decodedString = Encode.decode(encryptedData);
console.log("Decoded:", decodedString);

// 4. 验证结果
// console.log("Are they same?", originalString === decodedString);

